// ─── Utilities ────────────────────────────────────────────────────────────────

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

// ─── Year ─────────────────────────────────────────────────────────────────────

function setCurrentYear() {
  const el = $('#year');
  if (el) el.textContent = new Date().getFullYear();
}

// ─── Preloader ───────────────────────────────────────────────────────────────

function initPreloader() {
  const preloader = $('.preloader');
  if (!preloader) return;

  window.addEventListener('load', () => {
    preloader.classList.add('preloader--hidden');
    setTimeout(() => {
      preloader.remove();
    }, 600);
  });
}

// ─── Init ─────────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  setCurrentYear();
  initPreloader();
  console.log('🚀 Site ready.');
});
